



















import Vue from "vue";

import Close from "./Close.vue";

export default Vue.extend({
  name: "Modal",
  components: { Close },
  props: {
    big: Boolean,
    medium: Boolean,
    auto: Boolean,
    persistent: Boolean,
  },
});
